const BUSINESS_UNIT_ID_REG = /([1-9])(-)([a-z]{1,3})(-)([a-z]{1,3})(-)([a-z]{1,3})\w+/;
const WRONG_BUSINESS_UNIT_ID = 'Please provide a valid business unit id like 1-xx-xx-xx';

export class BusinessUnitIdParser {
    public brand: string = '';
    public region: string = 'us';
    public language: string = 'en';

    constructor(businessUnitId: string) {
        const separator = '-';
        if (!BUSINESS_UNIT_ID_REG.test(businessUnitId)) {
            throw new Error(WRONG_BUSINESS_UNIT_ID);
        }

        const [brand, region, language] = businessUnitId.split(separator).slice(-4);
        this.brand = brand;
        this.region = region;
        this.language = language;
    }

    public get locale() {
        return `${this.language}-${this.region.toLocaleUpperCase()}`;
    }
}
